import { z } from 'zod';
import { localeSchema } from '../locale.js';
import { currencySchema } from './project.js';
export * from './yandex-auth.js';
export const telegramAuthSchema = z.object({
    initData: z.string().min(1, 'initData is required'),
    timeZone: z.string().min(1).optional(),
    locale: localeSchema.optional(),
    wuid: z.string().min(12).max(128).optional(),
});
export const telegramUserSchema = z.object({
    id: z.number(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    username: z.string().optional(),
    language_code: z.string().optional(),
    is_premium: z.boolean().optional(),
    allows_write_to_pm: z.boolean().optional(),
    photo_url: z.string().url().optional(),
});
export const telegramOAuthDataSchema = z.object({
    id: z.number(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    username: z.string().optional(),
    photo_url: z.string().url().optional(),
    auth_date: z.number(),
    hash: z.string(),
});
export const telegramOAuthRequestSchema = z.object({
    authData: telegramOAuthDataSchema,
    timeZone: z.string().min(1).optional(),
    locale: localeSchema.optional(),
    source: z.string().optional(),
    wuid: z.string().min(12).max(128).optional(),
});
export const telegramLoginRequestSchema = telegramOAuthRequestSchema.omit({ authData: true }).extend({
    idToken: z.string().min(1).max(16384),
});
export const appleAuthRequestSchema = z.object({
    identityToken: z.string().min(1, 'identityToken is required'),
    nonce: z.string().min(1).optional(),
    fullName: z
        .object({
        givenName: z.string().nullable().optional(),
        familyName: z.string().nullable().optional(),
    })
        .optional(),
    timeZone: z.string().min(1).optional(),
    locale: localeSchema.optional(),
    source: z.string().optional(),
    /** WUID визита на лендинге — связывает регистрацию с источником. */
    wuid: z.string().min(12).max(128).optional(),
});
/** Серверные фичи, зависящие от конфигурации окружения, а не от прав пользователя. */
export const userFeaturesSchema = z.object({
    /** Включены ли вложения (S3/Garage) — см. config.storage.enabled на API. */
    attachments: z.boolean(),
});
export const userProfileSchema = z.object({
    id: z.string(),
    tgUserId: z.string().nullable(),
    yandexId: z.string().nullable(),
    appleId: z.string().nullable(),
    email: z.string().nullable(),
    username: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    timeZone: z.string().nullable(),
    locale: localeSchema,
    defaultCurrency: currencySchema,
    /** Опционально: старые клиенты (мобилка) не обязаны знать про фичи. */
    features: userFeaturesSchema.optional(),
});
// Настройки еженедельного отчёта по конкретному проекту (per user↔project).
export const weeklyReportSubscriptionSchema = z.object({
    projectId: z.string(),
    enabled: z.boolean(),
    day: z.number().int().min(0).max(6),
    lastSentAt: z.string().nullable(),
    // false — пользователь никогда не касался настройки (можно предлагать),
    // true — уже решил, в том числе решил «нет».
    configured: z.boolean().default(false),
});
// Элемент ленты отчётов (история). Тело — текст отчёта (Telegram-HTML).
export const weeklyReportFeedItemSchema = z.object({
    id: z.string(),
    projectId: z.string().nullable(),
    projectTitle: z.string().nullable(),
    body: z.string().nullable(),
    mode: z.enum(['AUTO', 'MANUAL']),
    createdAt: z.string(),
    readAt: z.string().nullable(),
});
export const authResponseSchema = z.object({
    accessToken: z.string(),
    /** Пользователь был создан именно этим запросом, а не найден. Нужно,
     *  чтобы конверсию «визит → регистрация» считать по факту регистрации,
     *  а не по каждому входу. */
    isNewUser: z.boolean().optional(),
    user: z.object({
        id: z.string(),
        tgUserId: z.string().nullable(),
        yandexId: z.string().nullable(),
        appleId: z.string().nullable(),
        email: z.string().nullable(),
        username: z.string().nullable(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        avatarUrl: z.string().nullable(),
        timeZone: z.string().nullable(),
        locale: localeSchema,
        defaultCurrency: currencySchema,
    }),
});
//# sourceMappingURL=auth.js.map